export const unmask = (val) => `${val}`.replace(/[$, ]+/g, '');

export function numberUnmask(val) {
  const unMaskedNumbers = `${val}`.match(/\d+/g);
  return Array.isArray(unMaskedNumbers) ? unMaskedNumbers.join('') : '';
}

export function floatUnmask(val) {
  return `${val}`.match(/[\d.]+/g).join('');
}
